import React, { useState, useEffect, useCallback } from 'react';
import { Alert, Container } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

import SidebarDashboard from "../../../components/SidebarDashboard";
import CustomNavbar from "../../../components/CustomNavbar";
import HeaderWithSearchForm from "../../../components/header_with_search_form/HeaderWithSearchForm";  
import FilterButtons from "../../../components/filter_buttons/FilterButtons";
import { getFilterButtonsConfig } from './filterButtonsConfig';
import CustomTable from '../../../components/CustomTable';
import { customTableColumns } from './customTableColumns';
import CustomPagint from '../../../components/CustomPagint';
import { getEmployeesVacations } from '../../../redux/vacations/employees_vacations/actions';
import SearchAvanceForm from '../../../components/search_avance_form/SearchAvanceForm';
import { findUserRole } from '../../../utils/findValueFromArray';
import { searchTypes, roles } from './variables';
import EmployeeHalfDay from './EmployeeHalfDay';

const EmployeesVacations = () => {
  const [showEmployeeHalfDayModal, setShowEmployeeHalfDayModal] = useState(false);
  const [employee, setEmployee] = useState({});
  const [show, setShow] = useState(false);
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [filter, setFilter] = useState({
    type: searchTypes.SIMPLE_SEARCH,
    filter: ''
  });
  const [isShowSearchAvanceForm, setIsShowSearchAvanceForm] = useState(false);
  const [hasExecuted, setHasExecuted] = useState(false);
  
  const {isLoadingEmployeesVacations,
         employeesVacations,
         employeesVacationsFail} = useSelector(state => state.employeesVacations);

  const { userRoles } = useSelector((store) => store.auth);
  const pages = Math.ceil((employeesVacations ? employeesVacations.count : 0) / limit);
  const dispatch = useDispatch();
  
  const searchEmployeesVacations = useCallback((fs=offset, lm=limit, ft=filter) => {
    const params = {
      offset: fs,
      limit: lm,
      rol: findUserRole(userRoles, roles)
    }

    params[ft.type === 'SIMPLE_SEARCH' ? 'filtro' : 'filtro_avanzado'] = ft.filter;
  
    dispatch(getEmployeesVacations(params));
  }, [offset, limit, filter, userRoles, dispatch]);

  const onShowSidebar = () => setShow(show ? false : true);

  const resetPagination = () => {
    setOffset(0);
    setCurrentPage(1);
  }
 
  const onListAll = () => {
    const ft = "";
    setFilter(ft);
    resetPagination();
    searchEmployeesVacations(0, limit, ft);
  }
  
  const onShowSearchAvanceForm = () => {
    setIsShowSearchAvanceForm(true);
  }

  useEffect(() => {
    if (!hasExecuted && userRoles.length > 0) {
      setHasExecuted(true);
      searchEmployeesVacations();
    }
  }, [userRoles, hasExecuted, searchEmployeesVacations]);
  
  const onSearch = (e) => {
    e.preventDefault();
    resetPagination();
    const ft = {type: searchTypes.SIMPLE_SEARCH, filter: e.target.search.value};
    setFilter(ft);
    searchEmployeesVacations(0, limit, ft);
  };

  const avancedSearch = (avancedSearchParams) => {
    //Avanced search is a object with the following structure:
    //{ companys: [], divisions: [], units: [], employees: [] }
    resetPagination();
    const ft = {
      type: searchTypes.ADVANCED_SEARCH,
      filter: avancedSearchParams
    };
    setFilter(ft);
    searchEmployeesVacations(0, limit, ft);
  }

  const showEmployeeHalfDaysModal = (showModal, emp) => {
    setShowEmployeeHalfDayModal(showModal);
    setEmployee(emp);
  }

  const filterButtonsConfig  = getFilterButtonsConfig(onListAll, onShowSearchAvanceForm, findUserRole(userRoles, roles)); 
  const customColumns = customTableColumns(showEmployeeHalfDaysModal);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <HeaderWithSearchForm 
            onSearch={onSearch} 
            title="Saldo de vacaciones por empleado"
            showNewRecordButton={false} />
          <hr />
          <FilterButtons buttons={filterButtonsConfig} />
          {
            employeesVacationsFail && (
              <Alert variant="danger" className="mt-4 mb-3 mx-3">
                {employeesVacationsFail}
              </Alert>
            )
          }
          <div className="mt-3">
            <CustomTable 
              isLoadingData={isLoadingEmployeesVacations}
              columns={customColumns} 
              data={employeesVacations && employeesVacations.data ? employeesVacations.data : []} />
            {
              employeesVacations && employeesVacations.count === 0 && !isLoadingEmployeesVacations && (
                <Alert variant="info" className="mt-2 mb-3 mx-3">
                  No se encontraron registros
                </Alert>
              )
            }
          </div>
          <CustomPagint
            limit={limit}
            setLimit={setLimit}
            offset={offset}
            setOffset={setOffset}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            dataLenght={employeesVacations && employeesVacations.count ? employeesVacations.count : 0}
            pages={pages}
            pagFunc={searchEmployeesVacations} />
        </Container>
      </div>
      <SearchAvanceForm 
        isShowSearchModal={isShowSearchAvanceForm} 
        setIsShowSearchModal={setIsShowSearchAvanceForm}
        searchFunc={avancedSearch} />
      <EmployeeHalfDay
        employee={employee}
        setShow={setShowEmployeeHalfDayModal}
        show={showEmployeeHalfDayModal} />
    </>
  )
}

export default EmployeesVacations;